module.exports = __webpack_public_path__ + "static/media/lidcore-mockup-7.cc53ba9b.jpg";